import 'zone.js';
import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';
import { shouldActivateWidget } from './app/widget-activation';
import { initWidgetSentry, widgetSentry } from './app/widget-sentry';

if (environment.production) {
  enableProdMode();
}

// Overall gate: only bootstrap the widget on allowed hosts (localhost / brafton.com
// subdomains except www), or anywhere with ?brafton-feedback=true. Sentry is only
// initialised when the widget actually activates, so dormant host pages aren't
// monitored.
if (shouldActivateWidget(window.location)) {
  // The widget's own, isolated Sentry client: never Sentry.init, which would also
  // report the host site's errors. See widget-sentry.ts.
  initWidgetSentry({ dsn: environment.sentryDsn, environment: environment.name });

  platformBrowserDynamic()
    .bootstrapModule(AppModule)
    .catch((bootstrapError) => {
      widgetSentry.scope?.captureException(bootstrapError);
      console.error(bootstrapError);
    });
}
